import { Component, inject, Input, OnInit } from "@angular/core";
import { HighchartsRenderComponent } from "../highcharts-render/highcharts-render.component";
import { CompanyEntity } from "@arch/domain/entity/company.entity";
import { VisualizationOptionsType } from "@arch/_shared/types/options-visualization";
import { VisualizationEntity } from "@arch/domain/entity/visualization.entity";
import { PointEntity } from "@arch/domain/entity/point.entity";
import { SerieEntity } from "@arch/domain/entity/serie.entity";
import { ColorsService } from "@arch/domain/application/services/colors.service";
import { ChartHistoricCategoryType } from "@arch/_shared/types/charts.types";
import { ChartHistoricFormatterService } from "@arch/domain/application/services/_highchart/chart-historic-formatter.service";
import { IndicatorComparationsResultType } from "@arch/domain/application/usecase/get-indicator-comparations.usecase";
import { GetIndicatorComparationsController } from "@arch/presentation/controllers";

@Component({
    selector: "app-chart-historic",
    imports: [HighchartsRenderComponent],
    templateUrl: "./chart-historic.component.html",
    styleUrl: "./chart-historic.component.scss"
})
export class ChartHistoricComponent implements OnInit {
    @Input({ required: false }) loading: boolean;
    @Input() options: VisualizationOptionsType;
    @Input() visualization: VisualizationEntity;
    @Input() company: CompanyEntity;
    @Input() points: PointEntity[];
    @Input() series: SerieEntity[];
    @Input({ required: false }) categoryName: ChartHistoricCategoryType;

    private readonly chartHistoricFormatterService = inject(
        ChartHistoricFormatterService
    );
    private readonly getIndicatorComparationsController = inject(
        GetIndicatorComparationsController
    );

    ngOnInit(): void {
        const comparations = this.getComparations(
            this.series,
            this.options,
            this.company
        );
        const chartModel: any = this.chartHistoricFormatterService.formatter(
            this.categoryName ||
                this.visualization.options.chartHistoricCategory,
            this.series,
            this.company,
            this.options,
            this.visualization,
            comparations
        );
        if (this.options.goals && this.visualization.props?.goals?.length) {
            chartModel.goals = this.visualization.props?.goals.map((goal) => {
                const color = ColorsService.getLowerTonality(
                    chartModel?.series?.[0]?.color || "goals.medium"
                );
                return {
                    _id: goal.r,
                    color: color,

                    type: "line",
                    dashStyle: "ShortDash"
                };
            });
        }

        this.visualization.chart = chartModel;
    }

    private getComparations(
        series: SerieEntity[],
        options: VisualizationOptionsType,
        company: CompanyEntity
    ): IndicatorComparationsResultType[] {
        const comparations = this.getIndicatorComparationsController.execute({
            company,
            series,
            options
        });
        return comparations;
    }
}
